export default __webpack_public_path__ + "static/media/us_6.2e1ca0eb.mp3";